import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import styled, { css } from "styled-components";

export const TabWrapper = styled.div`
  align-items: stretch;
  display: flex;
  gap: 20px;
  justify-content: center;
  padding: 24px 0 20px;
  z-index: 3;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    gap: 8px;
    padding-top: 16px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    padding-top: 8px;
  }
`;

export const Label = styled.span`
  color: ${({ theme }) => theme.colors.neutral11};
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: -0.36px;
  line-height: normal;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    font-size: 16px;
    height: 100%;
  }

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    display: none;
  }
`;

export const Tab = styled.button<{ $isActive: boolean }>`
  align-items: center;
  background: ${({ theme }) => theme.colors.neutral01};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.neutral03};
  box-shadow: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  max-height: 160px;
  max-width: 386px;
  outline: none;
  padding: 24px 0;
  position: relative;
  transition: all 0.2s ease-in-out;
  width: 100%;

  ${({ $isActive }) =>
    $isActive &&
    css`
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
      background: ${({ theme }) => theme.colors.neutral00};
      border-color: transparent;
    `}

  &:hover {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
    border-color: transparent;
  }

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    padding: 16px 4px;
  }
`;

export const ImageWrapper = styled.div`
  max-height: 64px;
  min-height: 64px;
  width: 100%;
`;

export const TabImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;

export const ActiveIndicator = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.colors.neutral00};
  border-radius: 50%;
  bottom: 0;
  display: flex;
  height: 26px;
  justify-content: center;
  left: 50%;
  position: absolute;
  transform: translate(-50%, 50%);
  width: 26px;

  svg {
    color: ${({ theme }) => theme.colors.neutral11};
    flex-shrink: 0;
    margin-top: 1px;
  }
`;
